import {
  AfterViewChecked,
  Directive,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { fromEvent, Subject, timer } from 'rxjs';
import { debounce, takeUntil } from 'rxjs/operators';
import { MatMenuPanel } from '@angular/material/menu';

export interface NavMenuItem {
  label: string;
  link?: string;
  routerLink?: string;
  icon?: string;
  submenu?: MatMenuPanel;
  permissions?: any;
  disabled?: boolean;
}

@Directive({
  selector: '[brnNavMenuCollapsed]',
})
export class NavMenuCollapsedDirective
  implements OnInit, OnDestroy, AfterViewChecked {
  @Input() navMenuRoutes!: HTMLElement;
  @Input() navMenuItems: NavMenuItem[] = [];
  @Input() navMenuItemsMore: NavMenuItem[] = [];

  private resizeTimeout: number = 100;
  private navMenuWidth: number = 0;
  private unsubscribe$: Subject<any> = new Subject();

  constructor(private navMenu: ElementRef, private ngZone: NgZone) {}

  ngAfterViewChecked() {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        const prevNavMenuWidth = this.navMenuWidth,
          navMenuRoutesWidth = this.navMenuRoutes.offsetWidth,
          navMenuRoutesLeft = this.navMenuRoutes.offsetLeft;
        this.navMenuWidth = this.navMenu.nativeElement.offsetWidth;

        if (
          this.navMenuWidth > prevNavMenuWidth &&
          navMenuRoutesLeft + navMenuRoutesWidth < this.navMenuWidth &&
          this.navMenuItemsMore.length
        ) {
          this.navMenuWidth = 0;
          this.ngZone.run(() => {
            this.expandBotMenu();
          });
        } else if (
          this.navMenuWidth &&
          navMenuRoutesLeft + navMenuRoutesWidth > this.navMenuWidth &&
          this.navMenuItems.length
        ) {
          this.ngZone.run(() => {
            this.collapseBotMenu();
          });
        }
      }, 0);
    });
  }

  ngOnInit(): void {
    this.ngZone.runOutsideAngular(() => {
      fromEvent(window, 'resize')
        .pipe(
          takeUntil(this.unsubscribe$),
          debounce(() => timer(this.resizeTimeout))
        )
        .subscribe(() => {
          this.ngZone.run(() => {});
        });
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private expandBotMenu() {
    const item = this.navMenuItemsMore.shift();
    if (item) {
      this.navMenuItems.push(item);
    }
  }

  private collapseBotMenu() {
    const item = this.navMenuItems.pop();
    if (item) {
      this.navMenuItemsMore.unshift(item);
    }
  }
}
